import type { ReactNode } from 'react';
import { ServicioNoDisponible } from '@/shared/components/ServicioNoDisponible';
import { reintentarErp, useErpNoDisponible } from '../estado-erp';

/**
 * GH#2765 — envuelve cada pantalla `/erp/*`. Mientras el API responda 503 `ERP_NOT_AVAILABLE` (el ERP no está desplegado) dice «en
 * construcción» en vez de dejar KPIs en cero y un aviso de error. El menú NO cambia (decisión de Randhy: el ERP se queda y se termina).
 */
export function ErpDisponible({ children }: { children: ReactNode }) {
  const enConstruccion = useErpNoDisponible();
  if (!enConstruccion) return <>{children}</>;
  return (
    <ServicioNoDisponible
      titulo="Esta sección está en construcción"
      descripcion="Estamos terminando el módulo contable (asientos, reportes DGII y comprobantes). Todavía no hay datos que mostrar; cuando esté listo, lo verás aquí."
      accion={{ texto: 'Reintentar', onClick: reintentarErp }}
    />
  );
}
